import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "select-box_container" }
const _hoisted_2 = { class: "select-box__label" }
const _hoisted_3 = { class: "select-box__label-text" }
const _hoisted_4 = { class: "select-box__modal-container" }
const _hoisted_5 = { class: "select-box__modal" }
const _hoisted_6 = { class: "select-box__modal-title" }
const _hoisted_7 = { class: "select-box__modal-text" }
const _hoisted_8 = { class: "select-box__modal-text--bold" }
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "select-box__dropdown" }
const _hoisted_11 = { class: "select-box__option" }
const _hoisted_12 = ["onClick"]

import { ref, watch, computed, onMounted, onUnmounted } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { BulkOrderInfo, BulkOrderInfoType } from '../domains/valueObjects/BulkOrderInfo';
import NumberInputWithComma from '@/corePagesModule/components/NumberInputWithComma.vue';
import { i18n } from '@/i18n';

type Options = {
  text: string;
  value: BulkOrderInfo;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'BulkOrderSelectInput',
  props: {
    index: {},
    modelValue: {},
    placeholder: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

/**
 * 選択された値を表す型
 */
const props = __props;

const orderAmount = ref<number>(0);

const options = computed((): Options[] => {
  const amount = orderAmount.value ?? 0;
  return [
    {
      text: `${amount.addComma()}${t('以上')}`,
      value: {
        amount,
        type: BulkOrderInfoType.MIN,
      },
    },
    {
      text: `${amount.addComma()}${t('以下')}`,
      value: {
        amount,
        type: BulkOrderInfoType.MAX,
      },
    },
    {
      text: `${amount.addComma()}`,
      value: {
        amount,
        type: BulkOrderInfoType.IS,
      },
    },
  ];
});

const selected = ref<BulkOrderInfo>(props.modelValue);
const selectedText = ref<string>('');
const isOpen = ref(false);

const emit = __emit;

watch(
  () => props.modelValue,
  () => {
    selected.value = props.modelValue;
  }
);

/**
 * placeholderを表示するかどうか
 */
const isPlaceholder = computed(() => {
  return selected.value.amount === 0 || selected.value === null || selected.value === undefined;
});

/**
 * ドロップダウンの表示状態を切り替えます。
 */
const toggleDropdown = () => {
  if (!props.disabled) {
    isOpen.value = !isOpen.value;
  }
};

/**
 * オプションを選択し、親コンポーネントに選択値を通知します。
 * @param option - 選択されたオプション
 */
const selectOption = (option: Options) => {
  if (option.value.amount === 0) return;
  selected.value = option.value;
  selectedText.value = option.text;
  emit('update:modelValue', option.value);
  isOpen.value = false;
};

/**
 * ドロップダウンを閉じます。
 * @param event - クリックイベント
 */
const closeDropdown = (event: MouseEvent) => {
  if (!isOpen.value) return;
  const target = event.target;
  const selector = `#order-status-select-${props.index}`;
  const arrowSelector = `#order-status-select-arrow-${props.index}`;
  if (!(target instanceof Element)) return;
  if (target.closest(arrowSelector)) return;
  if (target.closest(selector)) return;

  isOpen.value = false;
};

/**
 * onInputイベントハンドラ
 * @param value - 入力値
 */
const onInput = (value: string) => {
  orderAmount.value = Number(value);
  if (orderAmount.value === 0) {
    const resetValue = {
      amount: 0,
      type: BulkOrderInfoType.MIN,
    };

    selected.value = resetValue;
    selectedText.value = '';
    emit('update:modelValue', resetValue);
  }
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onUnmounted(() => {
  document.removeEventListener('click', closeDropdown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('まとめ発注')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SvgLoader, {
          class: "select-box__question-icon",
          name: "questionIcon"
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(t)('まとめ発注とは')), 1),
          _createElementVNode("p", _hoisted_7, [
            _createTextVNode(_toDisplayString(_unref(t)('まとめ発注は、')) + " ", 1),
            _createElementVNode("b", _hoisted_8, _toDisplayString(_unref(t)('仕入先と発注数量のルールが定まっている際に使用します。')), 1),
            _createTextVNode(" " + _toDisplayString(_unref(t)('同日納期かつ特定の仕入先と置場向けの複数発注の数量をまとめて規定の数量以上、以下、ちょうどを判断します。')), 1),
            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_unref(t)(
                '例えば関東で製造している仕入先Aと九州倉庫向けは10tonで発注するというルールが存在した場合、複数発注をまとめて10tonとなっているか確認する場合に使用します。'
              )) + " " + _toDisplayString(_unref(t)('まとめ発注欄で数量と条件を指定することで単一日ごとに条件に合致していない場合はアラートが表示されます。')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      id: `order-status-select-${_ctx.index}`,
      class: "select-box"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["select-box__selected", { 'select-box__selected--disabled': _ctx.disabled }]),
        onClick: toggleDropdown
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(`select-box__field ${isPlaceholder.value ? 'select-box__field--placeholder' : ''} ${
            _ctx.disabled ? 'select-box__selected--disabled' : ''
          }`)
        }, _toDisplayString(isPlaceholder.value ? _ctx.placeholder : selectedText.value), 3),
        _withDirectives(_createVNode(SvgLoader, {
          id: `order-status-select-arrow-${_ctx.index}`,
          name: "arrowDown",
          class: "select-box__arrow"
        }, null, 8, ["id"]), [
          [_vShow, !isOpen.value]
        ]),
        _withDirectives(_createVNode(SvgLoader, {
          name: "arrowUp",
          class: "select-box__arrow"
        }, null, 512), [
          [_vShow, isOpen.value]
        ])
      ], 2),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(NumberInputWithComma, {
            "model-value": orderAmount.value,
            type: "number",
            class: "select-box__input",
            placeholder: _unref(t)('数量を記入してください'),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = (e) => (orderAmount.value = e)),
            onInput: onInput
          }, null, 8, ["model-value", "placeholder"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
          return (_openBlock(), _createElementBlock("div", {
            key: option.value.amount,
            class: "select-box__option",
            onClick: ($event: any) => (selectOption(option))
          }, _toDisplayString(option.text), 9, _hoisted_12))
        }), 128))
      ], 512), [
        [_vShow, isOpen.value]
      ])
    ], 8, _hoisted_9)
  ]))
}
}

})